export const registrationInitialState = {
  auth: {
    isAuthenticated: false,
    user: null
  },
  selectedCenterId: null,
  selectedRetreatId: null,
  retreatSessionIdsSelected: [],
  selectedSessions: [],
  students: [],
  selectedStudentIds: [],
  studentSessionAssignments: {},
  submission: {
    status: 'idle',
    confirmationId: null,
    submittedAt: null
  }
};

export const registrationActionTypes = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGOUT: 'LOGOUT',
  RESET_REGISTRATION: 'RESET_REGISTRATION',
  SELECT_CENTER: 'SELECT_CENTER',
  SELECT_RETREAT: 'SELECT_RETREAT',
  SET_RETREAT_SESSIONS: 'SET_RETREAT_SESSIONS',
  SET_SELECTED_SESSIONS: 'SET_SELECTED_SESSIONS',
  UPSERT_STUDENT: 'UPSERT_STUDENT',
  REMOVE_STUDENT: 'REMOVE_STUDENT',
  TOGGLE_STUDENT_SELECTED: 'TOGGLE_STUDENT_SELECTED',
  SET_STUDENT_SESSIONS: 'SET_STUDENT_SESSIONS',
  SUBMIT_SUCCESS: 'SUBMIT_SUCCESS'
};

export function registrationReducer(state, action) {
  switch (action.type) {
    case registrationActionTypes.LOGIN_SUCCESS: {
      try {
        localStorage.setItem('yk_auth', JSON.stringify({ user: action.payload }));
      } catch {
        // ignore
      }
      return {
        ...state,
        auth: {
          isAuthenticated: true,
          user: action.payload
        }
      };
    }

    case registrationActionTypes.LOGOUT: {
      try {
        localStorage.removeItem('yk_auth');
      } catch {
        // ignore
      }
      return {
        ...registrationInitialState
      };
    }

    case registrationActionTypes.RESET_REGISTRATION: {
      return {
        ...state,
        selectedCenterId: null,
        selectedRetreatId: null,
        retreatSessionIdsSelected: [],
        selectedStudentIds: [],
        studentSessionAssignments: {},
        submission: {
          status: 'idle',
          confirmationId: null,
          submittedAt: null
        }
      };
    }

    case registrationActionTypes.SELECT_CENTER: {
      return {
        ...state,
        selectedCenterId: action.payload,
        selectedRetreatId: null,
        retreatSessionIdsSelected: [],
        selectedStudentIds: [],
        studentSessionAssignments: {},
        submission: {
          status: 'idle',
          confirmationId: null,
          submittedAt: null
        }
      };
    }

    case registrationActionTypes.SELECT_RETREAT: {
      return {
        ...state,
        selectedRetreatId: action.payload,
        retreatSessionIdsSelected: [],
        studentSessionAssignments: {},
        submission: {
          status: 'idle',
          confirmationId: null,
          submittedAt: null
        }
      };
    }

    case registrationActionTypes.SET_RETREAT_SESSIONS: {
      return {
        ...state,
        retreatSessionIdsSelected: action.payload
      };
    }

    case registrationActionTypes.SET_SELECTED_SESSIONS: {
      return {
        ...state,
        selectedSessions: action.payload
      };
    }

    case registrationActionTypes.UPSERT_STUDENT: {
      const next = action.payload;
      const existingIndex = state.students.findIndex((s) => s.id === next.id);
      const students = existingIndex >= 0
        ? state.students.map((s) => (s.id === next.id ? next : s))
        : [...state.students, next];

      return {
        ...state,
        students
      };
    }

    case registrationActionTypes.REMOVE_STUDENT: {
      const studentId = action.payload;
      const students = state.students.filter((s) => s.id !== studentId);
      const selectedStudentIds = state.selectedStudentIds.filter((id) => id !== studentId);
      const studentSessionAssignments = { ...state.studentSessionAssignments };
      delete studentSessionAssignments[studentId];

      return {
        ...state,
        students,
        selectedStudentIds,
        studentSessionAssignments
      };
    }

    case registrationActionTypes.TOGGLE_STUDENT_SELECTED: {
      const studentId = action.payload;
      const isSelected = state.selectedStudentIds.includes(studentId);
      const selectedStudentIds = isSelected
        ? state.selectedStudentIds.filter((id) => id !== studentId)
        : [...state.selectedStudentIds, studentId];

      return {
        ...state,
        selectedStudentIds
      };
    }

    case registrationActionTypes.SET_STUDENT_SESSIONS: {
      const { studentId, sessionIds } = action.payload;
      return {
        ...state,
        studentSessionAssignments: {
          ...state.studentSessionAssignments,
          [studentId]: sessionIds
        }
      };
    }

    case registrationActionTypes.SUBMIT_SUCCESS: {
      return {
        ...state,
        submission: {
          status: 'submitted',
          confirmationId: action.payload.confirmationId,
          submittedAt: action.payload.submittedAt
        }
      };
    }

    default:
      return state;
  }
}
